<template>
  <div class="">
    <!-- <div class="title mb-5 has-text-weight-bold">Areas Seeking Mentorship</div> -->

    <FormErrors v-bind:errors="fields.errors.detail" />

    <div class="field">
      <label class="label">Mentor category</label>
      <div class="control">
        <div v-if="allow_editing" class="">
          <div>
            <ul class="">
              <li
                v-for="item in fields.selected.designation_label"
                v-bind:key="item.uid"
                class="columns"
              >
                <p class="column is-four-fifths">{{ item.label }}</p>

                <!-- <p
                  class="column is-1 text-weight-bold tag is-light mr-6"
                  v-bind:class="{
                    'is-danger': item.priority === 2,
                    'is-warning': item.priority === 1,
                    'is-success': item.priority === 0,
                  }"
                >
                  {{ PRIORITY_VALUES[item.priority] }}
                </p>  -->
                <button
                  class="button is-responsive is-danger mr-2"
                  v-on:click = "delete_designation(item)" > Delete </button>
              </li>
            </ul>
            
          </div>
          <div class="columns my-3 mx-1 select is-fullwidth">
            <select v-model="fields.selected.designation.uid">
              <option value="select" selected disabled>--Select--</option>
              <option
                v-for="(designation, index) in fields.options.designation"
                v-bind:value="designation.uid"
                v-bind:key="index"
              >
                {{ designation.label }}
              </option>
            </select>
          </div>
          </div>
        <div v-else class="box is-rounded p-3">
          {{ fields.selected.designation.value }}
        </div>
        <FormErrors v-bind:errors="fields.errors.designation" />
          <button class="button is-primary has-text-weight-bold" v-on:click="add_designation">Add</button>
      </div>
    </div>


    <!-- <div class="field">
      <label class="label">Mentor category</label>
      <div class="control">
        <div v-if="allow_editing" class="select is-fullwidth">
          <select v-model="fields.selected.designation.uid">
            <option
              v-for="(designation, index) in fields.options.designation"
              v-bind:value="designation.uid"
              v-bind:key="index"
            >
              {{ designation.label }}
            </option>
          </select>
        </div>
        <div v-else class="box is-rounded p-3">
          {{ fields.selected.designation.value }}
        </div>

        <FormErrors v-bind:errors="fields.errors.designation" />
      </div>
    </div> -->

    <!-- <div class="field">
      <label class="label">Department</label>
      <div class="control">
        <div v-if="allow_editing" class="select is-fullwidth">
          <select v-model="fields.selected.department.uid">
            <option
              v-for="(department, index) in fields.options.department"
              v-bind:value="department.uid"
              v-bind:key="index"
            >
              {{ department.label }}
            </option>
          </select>
        </div>
        <div v-else class="box is-rounded p-3">
          {{ fields.selected.department.value }}
        </div>

        <FormErrors v-bind:errors="fields.errors.department" />
      </div>
    </div> -->

    <div class="field">
      <label class="label">Areas of interest </label>
      <div class="control">
        <div v-if="allow_editing" class="">
          <div>
            <ul class="">
              <li
                v-for="item in fields.selected.discipline_label"
                v-bind:key="item.uid"
                class="columns"
              >
                <p class="column is-four-fifths">{{ item.label }}</p>

                <!-- <p
                  class="column is-1 text-weight-bold tag is-light mr-6"
                  v-bind:class="{
                    'is-danger': item.priority === 2,
                    'is-warning': item.priority === 1,
                    'is-success': item.priority === 0,
                  }"
                >
                  {{ PRIORITY_VALUES[item.priority] }}
                </p>  -->
                <button
                  class="button is-responsive is-danger mr-2"
                  v-on:click = "delete_discipline(item)" > Delete </button>
              </li>
            </ul>
            
          </div>
          <div class="columns my-3 mx-1 select is-fullwidth">
            <select v-model="fields.selected.discipline.uid">
              <option value="select" selected disabled>--Select--</option>
              <option
                v-for="(discipline, index) in fields.options.discipline"
                v-bind:value="discipline.uid"
                v-bind:key="index"
              >
                {{ discipline.label }}
              </option>
              <option value="other">Other</option>
            </select>
          </div>
          </div>
        <div v-else class="box is-rounded p-3">
          {{ fields.selected.discipline.value }}
        </div>
        <FormErrors v-bind:errors="fields.errors.discipline" />
        <div class="field has-text-left">
          <!-- <label class="label">Specialization</label> -->
          <div class="control">
            <input
              placeholder="Enter new area of interest"
              class="input"
              v-if="allow_editing"
              v-show="fields.selected.discipline.uid == 'other'"
              v-model="fields.selected.other_discipline.value"
            >
            </div>
          </div>
    
          <FormErrors v-bind:errors="fields.errors.specialization" />
          <button class="button is-primary has-text-weight-bold" v-on:click="add_discipline">Add</button>
      </div>
    </div>


    <div v-if="allow_editing" class="control pt-2">
      <button
        v-on:click="save"
        class="button is-fullwidth is-primary has-text-weight-bold"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from '../../api/my-axios';
import FormErrors from '../FormHelpers/FormErrors';
import InputBox from '../FormHelpers/InputBox';

export default {
  components: {
    InputBox,
    FormErrors,
  },
  props: {
    is_editable: {
      type: Boolean,
      default: false,
    },
    profile_uid: {
      type: String,
      default: null,
    },
    user_role: {
      // "mentor" or "mentee"
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
    ...mapGetters({
      role: 'role', // "mentor" or "mentee"
    }),
  },
  data() {
    return {
      allow_editing: false,
      to_show_user_role: this.user_role,
      to_show_profile_uid: this.profile_uid,

      fields: {
        request_token: {
          // mentor or mentee: ""
        },

        errors: {},

        options: {
          designation: [],
          // department: [],
          discipline: [],
        },

        selected: {
          designation_label: [],
          designation: {
            uid: '',
            value: '',
          },
          // department: {
          //   uid: '',
          //   value: '',
          // },
          discipline_label: [],
          discipline: {
            uid: '',
            value: '',
          },
          specialization: {
            value: '',
          },
          other_discipline:{
            value: '',
          }
        },
      },
    };
  },
  created() {
    // TODO Try to fetch all three field options in one-go
    /* TODO Due to concurrent requests, selected options part may run before all options have been fetched
     * leading to empty boxes. Use promises (axios.all()) or async-await to ensure proper run order
     * */

    this.to_show_profile_uid = this.profile_uid
      ? this.profile_uid
      : this.user.profile_uid;
    this.to_show_user_role = this.user_role ? this.user_role : this.role;
    this.allow_editing = this.is_editable
      ? this.to_show_profile_uid === this.user.profile_uid
      : false;

    this.get_field_options();
    this.get_currently_selected_options();
  },
  methods: {
    get_field_options() {
      for (const field in this.fields.options) {
        axios
          .get(`/api/${this.to_show_user_role}/${field}/`)
          .then((response) => {
            this.fields.options[field] = response.data;
          })
          .catch((error) => {
            this.fields.errors[field] = error.response
              ? error.response.data
              : { detail: [error.message] };
          });
      }
    },

    get_currently_selected_options() {
      axios
        .get(
          `/api/${this.to_show_user_role}/${this.to_show_user_role}/${this.to_show_profile_uid}/`
        )
        .then((response) => {
          // Response contains the selected UIDs
          // console.log(response)
          for (const field in this.fields.options) {
            this.fields.selected[field].uid = response.data[field];

            const obj = this.fields.options[field].find(
              (e) => e.uid === response.data[field]
            );
            this.fields.selected.discipline_label = response.data['discipline_label']
            this.fields.selected.designation_label = response.data['designation_label']
            console.log(this.fields.selected)
            this.fields.selected[field].value = obj ? obj.label : '';
          }

          this.fields.selected.specialization.value =
            response.data.specialization;
        })
        .catch((error) => {
          this.fields.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    add_discipline()
    {
      axios.post(`/api/${this.role}/mentor_discipline/`, {
        discipline: this.fields.selected.discipline,
        specialization: this.fields.selected.other_discipline.value,
        delete: false,
      })
      .then((response) => {
        this.fields.selected.discipline_label.push(response.data)
        const index = this.fields.options.discipline.indexOf(response.data);
        if (index < 0) {
          this.fields.options.discipline.push(response.data);
        }
        this.fields.selected.discipline = {uid: 'select', value: 'select'}
      })
      .catch((error) => {})
    },

    delete_discipline(item)
    {
      axios.post(`/api/${this.role}/mentor_discipline/`, {
        discipline: item,
        specialization: this.fields.selected.other_discipline.value,
        delete: true,
      })
      .then((response) => {
        const index = this.fields.selected.discipline_label.indexOf(item);
        if (index > -1) { // only splice array when item is found
          this.fields.selected.discipline_label.splice(index, 1); // 2nd parameter means remove one item only
        }
      })
    },

    add_designation()
    {
      axios.post(`/api/${this.role}/mentor_designation/`, {
        designation: this.fields.selected.designation,
        delete: false,
      })
      .then((response) => {
        this.fields.selected.designation_label.push(response.data)
        // const index = this.fields.options.designation.indexOf(response.data);
        // if (index < 0) {
        //   this.fields.options.designation.push(response.data);
        // }
        this.fields.selected.designation = {uid: 'select', value: 'select'}
      })
      .catch((error) => {})
    },

    delete_designation(item)
    {
      axios.post(`/api/${this.role}/mentor_designation/`, {
        designation: item,
        delete: true,
      })
      .then((response) => {
        const index = this.fields.selected.designation_label.indexOf(item);
        if (index > -1) { // only splice array when item is found
          this.fields.selected.designation_label.splice(index, 1); // 2nd parameter means remove one item only
        }
      })
    },

    save() {
      if (!this.allow_editing) {
        return;
      }
      if (this.fields.selected.designation.value == "select") {
        this.$forceUpdate()
          this.$store.commit("set_show_alert", {show: true, message: 'Mentorship wishlist updated', type: 'primary'});
          setTimeout(() => {
              this.$store.commit("set_show_alert", {show: false, message: '', type: ''});
          }, 1000);
          return;
      }
      axios
        .patch(`/api/${this.role}/${this.role}/${this.user.profile_uid}/`, {
          designation: this.fields.selected.designation.uid,
          // department: this.fields.selected.department.uid,
          // discipline: this.fields.selected.discipline,
          // specialization: this.fields.selected.other_discipline.value,
          // other_discipline: this.fields.selected.other_discipline.value,
        })
        .then(() => {
          this.$forceUpdate()
          this.$store.commit("set_show_alert", {show: true, message: 'Mentorship wishlist updated', type: 'primary'});
          setTimeout(() => {
              this.$store.commit("set_show_alert", {show: false, message: '', type: ''});
          }, 1000);
        })
        .catch((error) => {
          this.fields.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },
  },
};
</script>
